import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import JournalPostForm from '../containers/JournalPostFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class JournalPostEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `JournalPostEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('journal_post_route_edit')} />
          <JournalPostForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default JournalPostEditScreen;

Logger.log('silly', `JournalPostEditScreen loaded.`);
